module.exports = __webpack_public_path__ + "static/media/profile.08e100f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/profile.jpg
// module id = 81
// module chunks = 0